import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";

@Injectable()
export class WaitService {
  message: string = "Analyzing ...";
  private _isAnalyzing: boolean = true;

  private waitingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public waitingChanged: Observable<boolean> = this.waitingSubject.asObservable();

  public dataLoadedChange: Subject<boolean> = new Subject();
  public isAnalyzingObserver: Subject<boolean> = new Subject();
  public resetData: Subject<boolean> = new Subject();

  public showMessage(message: string): void {
    this.message = message;
    this.waitingSubject.next(true);
  }

  public hideMessage(): void {
    this.waitingSubject.next(false);
  }

  public dataLoadedToggle(toggle: boolean): void {
    this.dataLoadedChange.next(toggle);
  }

  public isAnalyzingObserverToggle(toggle: boolean): void {
    this._isAnalyzing = toggle;
    this.isAnalyzingObserver.next(toggle);
  }

  get isAnalyzing(): boolean {
    return this._isAnalyzing;
  }

  public triggerResetData(trigger: boolean): void {
    this.resetData.next(trigger);
  }
}
